'use client';

import React, { useEffect, useRef } from 'react';

const steps = [
  {
    n: 'STEP 01',
    title: 'Define the target and the definition',
    body: 'We build your Ideal Customer Profile, write the qualified-meeting definition and its fee into your agreement, and map the signals that mark an account as in-market.',
    note: 'Free strategy session included',
  },
  {
    n: 'STEP 02',
    title: 'We build the system and train your reps',
    body: 'Verified calling data is built, supporting email and LinkedIn touches are prepared, and your reps complete pitch training, objection handling, and ICP immersion before the first dial.',
    note: 'Screened in person. Pitch-trained.',
  },
  {
    n: 'STEP 03',
    title: 'Qualified meetings hit your calendar',
    body: 'Your reps run the cadence, phone first. Performance builds over the first 60 to 90 days as targeting and messaging tune against real conversations. You review the numbers with us every week.',
    note: 'You close. We keep booking.',
  },
];

export default function ProcessSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            observer.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    const els = sectionRef?.current?.querySelectorAll('.rev');
    els?.forEach((el) => observer?.observe(el));
    return () => observer?.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-24">
      <div className="max-w-site mx-auto px-7">
        <div className="rev mb-13 max-w-[780px]">
          <div className="eyebrow">Our process</div>
          <h2 className="heading-2 text-ink">From strategy to booked meetings</h2>
        </div>

        <div className="bg-white border border-line-color rounded-brand px-9 py-3.5">
          {steps?.map((step, i) => (
            <div
              key={step?.n}
              className={`rev step-item ${i === steps?.length - 1 ? 'border-b-0' : ''}`}
              style={{ transitionDelay: `${i * 0.1}s` }}
            >
              <div className="font-mono text-[15px] text-primary font-semibold pt-1.5">
                {step?.n}
              </div>
              <div>
                <h3 className="heading-3 text-ink mb-2">{step?.title}</h3>
                <p className="text-muted-text text-[15.5px] leading-relaxed">{step?.body}</p>
                <span className="block font-mono text-[12px] tracking-[0.1em] text-primary uppercase mt-2.5">
                  {step?.note}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}